module.exports = __webpack_public_path__ + "img/meeymap.ca7b21f1.svg";